export default __webpack_public_path__ + "static/media/soham.92337ce7.jpeg";